import { render, staticRenderFns } from "./ParticaWebsite.vue?vue&type=template&id=5ed9cd91&"
import script from "./ParticaWebsite.vue?vue&type=script&lang=ts&"
export * from "./ParticaWebsite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports